import React, { FC } from 'react'

import { Box, Container } from '@material-ui/core'

import SimpleCard from '~/components/cards/SimpleCard'
import Flexbox from '~/components/shared/Flexbox'
import Link from '~/components/shared/Link'
import Text from '~/components/shared/Text'

import ArrowIcon from '~/assets/icons/arrow.svg?sprite'
import { possibilityConfig } from '~/data/mocks/sellYourVesselConfigs'

import { IS_BOAT } from '~/brands'

import Possibility from './Possibility'

interface SellWithUsSectionProps {
  redirectLink: string
}

const SellWithUsSection: FC<SellWithUsSectionProps> = ({ redirectLink }) => {
  return (
    <Container maxWidth="md">
      <Box mt={-5} position="relative" zIndex={1} mb={4} pb={4}>
        <SimpleCard pb={6}>
          <Text
            textAlign="center"
            fontFamily="Prompt, sans-serif"
            fontSize={{ xs: 24, md: 35 }}
            fontWeight={600}
          >
            {IS_BOAT ? (
              <>
                Why Sell With Trade
                <Box component="span" color="primary.main">
                  a
                </Box>
                Boat?
              </>
            ) : (
              <Text
                textAlign="center"
                fontFamily="Prompt, sans-serif"
                fontSize={{ xs: 24, md: 35 }}
                fontWeight={600}
              >
                Why Sell With TradeRV’s?
              </Text>
            )}
          </Text>

          <Flexbox
            justifyContent="center"
            alignItems="center"
            flexDirection={{ xs: 'column', md: 'row' }}
            mt={1}
          >
            <Text fontSize={{ xs: 16, md: 18 }}>National Coverage</Text>

            <Box
              width={7}
              height={7}
              alignSelf="center"
              mx={1.5}
              borderRadius="50%"
              bgcolor="primary.main"
            />

            <Text fontSize={{ xs: 16, md: 18 }}>
              Advertise to Buyers Across the Country
            </Text>
          </Flexbox>

          <Flexbox flexWrap="wrap" justifyContent="center">
            {possibilityConfig.map(({ text, maxWidthText }) => (
              <Possibility key={text} maxWidthText={maxWidthText} text={text} />
            ))}

            <Link href={redirectLink}>
              <Flexbox
                minWidth={300}
                borderRadius="4px"
                height={74}
                mt={3}
                py={1.5}
                mx={1.5}
                justifyContent="space-around"
                bgcolor="primary.main"
              >
                <Text
                  fontSize={30}
                  fontWeight={600}
                  fontFamily="Prompt, sans-serif"
                  style={{ color: 'white' }}
                >
                  Let’s Start
                </Text>

                <Box alignSelf="center">
                  <ArrowIcon />
                </Box>
              </Flexbox>
            </Link>
          </Flexbox>
        </SimpleCard>
      </Box>
    </Container>
  )
}

export default SellWithUsSection
